<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Refund Show Detail Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="fromDate"
                  @click="fromDate = ''"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="toDate"
                  @click="toDate = ''"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getRefundReportData((isExcel = 'N'))"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            class="col-lg-6 col-xl-3 align-self-center mb-3 d-flex justify-content-end align-items-center"
            v-if="getRefundReport.length > 0"
          >
            <div
              class="d-flex justify-content-end align-items-center"
              v-if="getRefundReport.length > 0"
            >
              <div class="mx-1">{{ $t("download") }} as:</div>
              <!-- <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->
              <a
                target="_blank"
                @click="getRefundReportData((isExcel = 'Y'))"
                title="Download as Excel"
                download
              >
                <img
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </a>
            </div>
          </div>
          <!-- <div
          class="d-flex justify-content-end mt-5 align-items-center"
          v-if="getFnBComboReport.length"
        >
          <div>{{ $t("download") }} as:</div>
          <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a href="#" @click="excelDownload()" title="Download as Excel">
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div> -->
        </div>
      </div>

      <div class="swc-report" style="overflow-x: auto">
        <table
          class="swc-report-table"
          border="1"
          style="width: auto !important"
          ref="exportable_table"
        >
          <thead>
            <tr class="bg-lightgrey">
              <th>Bussiness Date</th>
              <th>Transaction Id</th>
              <th>Transaction Date</th>
              <th>Reservation ID</th>
              <th>Invoice No.</th>
              <th>Refund Type</th>
              <th>Refund Date & Time</th>
              <th>Movie/Item</th>
              <!-- <th>OutLet</th>
                    <th>Movie/Item</th> -->
              <th>ShowDate</th>
              <th>Showtime</th>
              <!-- <th>POS ID</th> -->
              <!-- <th>User Id</th> -->
              <!-- <th>User Name</th> -->
              <th>PartnerId</th>
              <th>Terminal ID</th>
              <th>Transaction RRN</th>
              <th>STAN</th>
              <th>TVR</th>
              <th>Card No</th>
              <th>Approval Code</th>
              <th>QTY</th>
              <!-- <th>Unit Price</th> -->
              <th>Amount Before Tax</th>
              <template v-if="setCharges.length > 0">
                <template v-for="(charges, chargesIndex) in setCharges">
                  <th :key="chargesIndex + 'colone'">
                    {{ charges.charge_name }}
                  </th>
                </template>
              </template>
              <th>Total Amount</th>

              <th>Screen Name</th>
              <th>Seat Name</th>
              <!-- <th>Reservsation Id</th> -->
              <th>Email Id</th>
              <th>Mobile No</th>
            </tr>
          </thead>

          <tbody class="sph-report">
            <tr
              v-for="(refunddata, refunddataIndex) in getRefundReport"
              :key="refunddataIndex + 'coltwo'"
            >
              <td class="text-left">{{ refunddata.business_date }}</td>
              <td class="text-right">{{ refunddata.t_id }}</td>
              <td class="text-left">
                {{ refunddata.t_refund_date_time | dateparse }}
              </td>
              <td class="text-right">
                {{ refunddata.invoice_no ? refunddata.invoice_no : "-" }}
              </td>
              <td class="text-right">
                {{
                  refunddata.invoice_no_ticket
                    ? refunddata.invoice_no_ticket
                    : "-"
                }}
              </td>
              <td class="text-left">{{ refunddata.pm_payment_mode }}</td>
              <td>{{ refunddata.t_refund_date_time | fulldatemonparse }}</td>
              <td class="text-left">{{ refunddata.movie_name }}</td>
              <td>{{ refunddata.t_show_date }}</td>
              <td>{{ refunddata.t_show_time }}</td>
              <td class="text-right">
                {{
                  getSafe(
                    () =>
                      refunddata.payment_transaction_detail.transaction[
                        refunddata.payment_transaction_detail.transaction
                          .length - 1
                      ].transaction.acquirer.merchantId
                  ) || "-"
                }}
              </td>
              <td class="text-left">
                {{
                  getSafe(
                    () =>
                      refunddata.payment_transaction_detail.transaction[
                        refunddata.payment_transaction_detail.transaction
                          .length - 1
                      ].transaction.terminal
                  ) || "-"
                }}
              </td>
              <td class="text-right">
                {{
                  getSafe(
                    () => refunddata.payment_transaction_detail.fort_id
                  ) ||
                    getSafe(
                      () =>
                        refunddata.payment_transaction_detail.transaction[
                          refunddata.payment_transaction_detail.transaction
                            .length - 1
                        ].transaction.receipt
                    ) ||
                    "-"
                }}
              </td>
              <td class="text-right">
                {{
                  getSafe(
                    () =>
                      refunddata.payment_transaction_detail.transaction[
                        refunddata.payment_transaction_detail.transaction
                          .length - 1
                      ].authorizationResponse.stan
                  ) ||
                    getSafe(
                      () =>
                        refunddata.payment_transaction_detail.transaction[
                          refunddata.payment_transaction_detail.transaction
                            .length - 1
                        ].transaction.stan
                    ) ||
                    "-"
                }}
              </td>
              <td class="text-right">
                {{
                  getSafe(
                    () =>
                      refunddata.payment_transaction_detail.transaction[
                        refunddata.payment_transaction_detail.transaction
                          .length - 1
                      ].authorizationResponse.transactionIdentifier
                  ) || "-"
                }}
              </td>

              <td class="text-right">
                {{
                  getSafe(
                    () => refunddata.payment_transaction_detail.card_number
                  ) ||
                    getSafe(
                      () =>
                        refunddata.payment_transaction_detail.sourceOfFunds
                          .provided.card.number
                    ) ||
                    "-"
                }}
              </td>
              <td class="text-left">
                {{
                  getSafe(
                    () =>
                      refunddata.payment_transaction_detail.authorization_code
                  ) ||
                    getSafe(
                      () =>
                        refunddata.payment_transaction_detail.transaction[
                          refunddata.payment_transaction_detail.transaction
                            .length - 1
                        ].transaction.authorizationCode
                    ) ||
                    "-"
                }}
              </td>
              <!-- <td class="text-right">{{refunddata.t_refunded_payment_mode_id }}</td> -->
              <td class="text-right">1</td>
              <td class="text-right">
                {{ refunddata.t_net_amount.toFixed(2) }}
              </td>
              <template v-for="(charges, chargesIndex) in setCharges">
                <td :key="chargesIndex + 'cahrges_2'">
                  {{ refunddata[charges.charge_name] }}
                </td>
                <!-- <td>{{refunddata.t_net_amount + refunddata[charges.charge_name]}}</td> -->
              </template>
              <td class="text-right">
                {{ refunddata.t_refunded_amount.toFixed(2) || "0.00" }}
              </td>
              <!-- <td class="text-left">
                {{ refunddata.approver_id ? refunddata.approver_id : "-" }}
              </td> -->
              <td class="text-left">{{ refunddata.screen_name }}</td>
              <td class="text-left">{{ refunddata.seat_name }}</td>
              <!-- <td class="text-left">{{ refunddata.srt_unique_code }}</td> -->
              <td>
                {{
                  refunddata.booking_user_data
                    ? refunddata.booking_user_data.split(",")[0]
                    : "-"
                }}
              </td>
              <td>
                {{
                  refunddata.booking_user_data
                    ? refunddata.booking_user_data.split(",")[1]
                    : "-"
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-if="getRefundReport.length === 0">
            <tr>
              <td colspan="14">
                <!-- <p class="h6 text-center">{{ $tc("NoRecords") }}</p> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!---New-->
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import xlsx from "json-as-xlsx";
  import * as XLSX from "xlsx";

  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        getFnBComboReport: [],
        getFnBComboReportRecords: [],
        Allrecords: [],
        getRefundReport: [],
        setCharges: [],
        mainArr: [],
        isExcel: "N",
        excelPath: "",
      };
    },
    beforeMount() {
      // let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
      this.getCinemaList();
    },
    watch: {
      // setCharges:function(val){
      //     this.setCharges=val
      // }
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // }
    },
    mounted() {},
    methods: {
      ExportExcel(type, fn, dl) {
        var elt = this.$refs.exportable_table;
        var wb = XLSX.utils.table_to_book(elt, {
          sheet: "RefundShowDetailReport",
        });
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(
              wb,
              fn || "RefundShowDetailReport." + (type || "xlsx")
            );
      },
      excelDownload() {
        this.$forceUpdate();

        let temp_data = JSON.parse(JSON.stringify(this.getRefundReport || []));

        temp_data.forEach((x) => {
          Object.keys(x).forEach((k) => {
            if (x[k] == null) x[k] = "-";
          });
        });

        console.log({
          temp_data,
        });

        //   console.log(this.Allrecords);
        // let temp_arr = [];
        // temp_data.map(x => {
        //   x.charge_arr.map(y => {
        //     let obj = {
        //       ...x,
        //       ...y
        //     };
        //     temp_arr.push(obj);
        //   });
        // });
        // console.log({temp_arr})
        let dateparse = function(value) {
          if (!value) return "-";
          else if (value === "Invalid date") return "-";
          else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
            return value
              ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
              : "-";
          //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
          //this is changed acc to mams decision
          else
            return value
              ? moment(value).format("DD-MM-YYYY") === "Invalid date"
                ? "-"
                : moment(value).format("DD-MMM-YYYY")
              : "-";
        };
        let fulldatemonparse = function(value) {
          if (!value) return "-";
          else if (value === "Invalid date") return "-";
          else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
            return value
              ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
              : "-";
          //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
          //this is changed acc to mams decision
          else
            return value
              ? moment(value).format("DD-MM-YYYY") === "Invalid date"
                ? "-"
                : moment(value).format("DD-MMM-YYYY HH:mm")
              : "-";
        };

        let data = [
          {
            sheet: "Refund Show Detail Report",
            columns: [
              {
                value: "business_date",
                label: "Bussiness Date",
              },
              {
                value: "t_id",
                label: "Transaction Id",
              },
              //   {
              //   value: row => dateparse(row.t_refund_date_time),
              //   label: "Transaction Date"
              // },
              {
                value: "pm_payment_mode",
                label: "Refund Type",
              },
              {
                value: "movie_name",
                label: "Movie/Item",
              },
              //   {
              //   value: row => dateparse(row.t_show_date),
              //   label: "Show Date"
              // },

              {
                value: "t_show_time",
                label: "Show Time",
              },
              // {
              //   value: "t_refunded_payment_mode_id",
              //   label: "User Id"
              // },
              {
                value: 1,
                label: "QTY",
              },
              // {
              //   value: row => (row.t_net_amount ? +parseFloat(row.t_net_amount).toFixed(2):0),
              //   label: "Amount Before Tax"
              // },
              {
                value: "GCAM",
                label: "GCAM",
              },
              {
                value: "VAT",
                label: "VAT",
              },
              {
                value: "t_refunded_amount",
                label: "Total Amount",
              },
              {
                value: "screen_name",
                label: "Screen Name",
              },
              {
                value: "seat_name",
                label: "Seat Name",
              },
              // {
              //   value: row => (row && !!row.email ? row.email : '_'),
              //   label: "Email Id"
              // },
              // {
              //   value: row => (row && !!row.user_name ? row.user_name : '_'),
              //   label: "Mobile No"
              // },

              //      Sold: 0,
              // gross_amount: 0,
              // offer_price: 0,
              // total_taxes: 0,
              // final_gross_amount: 0
            ],
            content: temp_data,
          },
        ];
        let settings = {
          fileName: `RefundShowDetailReport${new Date().getTime()}`,
        };
        xlsx(data, settings);
      },
      getCinemaList: function() {
        MasterService.GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        console.log(event);
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
        // this.$store.dispatch("selectDropdownCinema", event);
      },

      getRefundReportData: function(isExcel) {
        let loader = this.$loading.show();
        // this.submitted = true;

        this.getRefundReport = [];
        this.setCharges = [];
        if (!this.dropDown.selectedCinemaId) {
          loader.hide();
          return this.$toasted.show("Please select a cinema");
        }
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          excel: isExcel,
        };
        ReportsService.GetRefundShowDetail(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              // console.log("data from api", data.Records);
              this.getRefundReport = data.Records;
              this.setCharges = data.chargeTypeArr;
              if ((isExcel = "Y" && data.excelPath)) {
                window.open(data.excelPath, "_blank");
              }
              // this.dataObj = this.getFnBComboReport.dataOdj;

              // this.getRefundReport.forEach(x => {
              //   console.log(
              //     "x.booking_user_data",
              //     x.booking_user_data,
              //     x.booking_user_data
              //       ? String(x.booking_user_data).split(",")
              //       : "NONE"
              //   );
              // });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 100);
          });
      },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    border: 1px solid black;
  }
  .swc-report-table th {
    border: 1px solid black !important;
  }
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .bg-lightblue {
    background-color: #3876d2 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/RefundShowDetailReport.vue